import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankAccount  {
    _originalTypeClassName = "zERP.BO.BankAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankAccount.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.PaymentOrderPaymentLine = [];
this.Bank = new Domain.Bank();
this.Id = null;
this.Code = null;
this.Name = null;
this.IBAN = null;
this.Branch = null;
this.ContractCode = null;
this.Description = null;
this.Type = null;
this.AccountNumber = null;
this.ContractDate = null;
this.CompanyCode = null;
this.Phone = null;
this.AccountSize = null;
this.InterestRate = null;
this.TypeStr = null;
this.Balance = null;
this.BlockedAmount = null;
this.AvailableBalance = null;
this.SkipBalanceCheck = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
IBAN:any;
Branch:any;
ContractCode:any;
Description:any;
Type:any;
AccountNumber:any;
ContractDate:any;
CompanyCode:any;
Phone:any;
AccountSize:any;
InterestRate:any;
TypeStr:any;
Balance:any;
BlockedAmount:any;
AvailableBalance:any;
SkipBalanceCheck:any;
Entity:any;
TransactionEntity:any;
PaymentOrderPaymentLine:any;
Bank:any;
Currency:any;
AccountingConfig:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
if (oldValue != null) {
Domain.BusinessEntity.removeBankAccounts(oldValue, $this);
}
Domain.BusinessEntity.addBankAccounts(value, $this);
}
}
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
if (oldValue != null) {
Domain.TransactionEntity.removeBankAccounts(oldValue, $this);
}
Domain.TransactionEntity.addBankAccounts(value, $this);
}
}
static setPaymentOrderPaymentLine = ($this, items) => {
                if (items == null) items = [];
                if ($this.PaymentOrderPaymentLine == null) $this.PaymentOrderPaymentLine = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PaymentOrderPaymentLine.length > 0) {
                    Domain.BankAccount.removePaymentOrderPaymentLine($this, $this.PaymentOrderPaymentLine[0]);
                }

                Domain.BankAccount.addManyPaymentOrderPaymentLine($this, copyItems);
            }
static addManyPaymentOrderPaymentLine = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BankAccount.addPaymentOrderPaymentLine($this, items[i]);
                }
            }
static addPaymentOrderPaymentLine = ($this, item) => {
                if ($this.PaymentOrderPaymentLine == null) $this.PaymentOrderPaymentLine = [];
                if (item == null || $this.PaymentOrderPaymentLine.indexOf(item) > -1) return;
                $this.PaymentOrderPaymentLine.push(item);
if (item.BankAccountFrom != $this) {
Domain.PaymentLine.setBankAccountFrom(item, $this);
}
}
static addRangePaymentOrderPaymentLine = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BankAccount.addPaymentOrderPaymentLine($this, item));
            }
static removePaymentOrderPaymentLine = ($this, item) => {
                if ($this == null || $this.PaymentOrderPaymentLine == null || $this.PaymentOrderPaymentLine.indexOf(item) === -1) return;
                var _index = $this.PaymentOrderPaymentLine.indexOf(item);
                $this.PaymentOrderPaymentLine.splice(_index, 1);
item.BankAccountFrom = null;
}
static clearPaymentOrderPaymentLine = ($this) => { $this.PaymentOrderPaymentLine = null; }
static setBank = ($this, value) => {
var oldValue = $this.Bank;
$this.Bank = value;
if (value != null) {
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}

static GetAvailableAmount($this: any): any{return Joove.Common.safeNumber($this?.Balance) - Joove.Common.safeNumber($this?.BlockedAmount);
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetTypeStr($this: any): any{switch ($this?.Type) {case Domain.BankAccountType.Current:
{
return this.translate.instant('CommonBO_RES_CUSTOM_BANC_ACCOUNT_TYPE_CURRENT');}
case Domain.BankAccountType.Savings:
{
return this.translate.instant('CommonBO_RES_CUSTOM_BANC_ACCOUNT_TYPE_SAVINGS');}
default:
{
return "";}
}
return "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}